import { Auth } from "domain/model/Auth"
import { Server } from "core/utils/axios"
import StudentProgressDataSource from "data/dataSource/Student/StudentProgressDataSource"
import { STUDENT } from "core/constants/strings"
import pn from "core/utils/pn"
import StudentExpierenceDataSource from "data/dataSource/Student/StudentExpierenceDataSource"
import { UpdateStudentExpierenceDetails } from "domain/model/UpdateStudentExpierence"
import { SessionRescheduleRequestDataSource } from "data/dataSource/Student/SessionRescheduleRequestDataSource"
import { CreateSessionRescheduleRequestDetails } from "domain/model/SessionRescheduleRequest"

const server = new Server()
export default class SessionRescheduleRequestAPIDataSourceImpl implements SessionRescheduleRequestDataSource {
  async createSessionRescheduleRequest(auth: Auth, details: CreateSessionRescheduleRequestDetails): Promise<any> {
    const response = await server.post(
      pn(STUDENT, "create_session_reschedule_request"),
      { details: details },
      {
        Authorization: `Bearer ${auth?.id_token}`,
      }
    )
    return response
  }

  async getSessionRescheduleRequest(auth: Auth): Promise<any> {
    const response = await server.get(pn(STUDENT, "get_session_reschedule_request"), {
      Authorization: `Bearer ${auth?.id_token}`,
    })
    return response
  }
}
